unit View.Sincronizacao_Aliados.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewSincronizacao_AliadosEdit = class(TWebForm)
    pnlMessage: TWebPanel;
    lbMessage: TWebLabel;
    btCloseMessage: TWebButton;
    DataSource: TWebDatasource;
    btCancel: TWebButton;
    btSave: TWebButton;
    btDelete: TWebButton;
    lbid: TWebLabel;
    edid: TWebDBEdit;
    lbaliado_id: TWebLabel;
    edaliado_id: TWebDBEdit;
    lbsincronizacao_service_id: TWebLabel;
    edsincronizacao_service_id: TWebDBEdit;
    lbsincronizar_dados: TWebLabel;
    edsincronizar_dados: TWebDBEdit;
    lbinclusao: TWebLabel;
    edinclusao: TWebDBEdit;
    lbalteracao: TWebLabel;
    edalteracao: TWebDBEdit;
    lbsincronizacao_service: TWebLabel;
    cbsincronizacao_service: TWebComboBox;
    XDataClientSincronizacao_AliadosGet: TXDataWebClient;
    XDataClientSincronizacao_AliadosDelete: TXDataWebClient;
    Sincronizacao_AliadosDataset: TXDataWebDataSet;
    Sincronizacao_AliadosDatasetid: TIntegerField;
    Sincronizacao_AliadosDatasetaliado_id: TIntegerField;
    Sincronizacao_AliadosDatasetsincronizacao_service_id: TIntegerField;
    Sincronizacao_AliadosDatasetsincronizar_dados: TBooleanField;
    Sincronizacao_AliadosDatasetinclusao: TDateTimeField;
    Sincronizacao_AliadosDatasetalteracao: TDateTimeField;
    Sincronizacao_AliadosDatasetsincronizacao_service: TXDataWebEntityField;
    sincronizacao_serviceDataset: TXDataWebDataSet;
    sincronizacao_serviceDatasetid: TIntegerField;
    sincronizacao_serviceDatasettabela: TStringField;
    sincronizacao_serviceDatasetcampos_consulta: TStringField;
    sincronizacao_serviceDatasetrota: TStringField;
    sincronizacao_serviceDatasetprioridade_sincronizacao: TIntegerField;
    sincronizacao_serviceDatasetexcluido: TBooleanField;
    sincronizacao_serviceDatasetinclusao: TDateTimeField;
    sincronizacao_serviceDatasetalteracao: TDateTimeField;
    sincronizacao_serviceDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientSincronizacao_AliadosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientSincronizacao_AliadosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientSincronizacao_AliadosDeleteError(Error: TXDataClientError);
    procedure Sincronizacao_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
    procedure sincronizacao_serviceDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TWebForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TWebForm; overload;
  end;

var
  FViewSincronizacao_AliadosEdit: TFViewSincronizacao_AliadosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSincronizacao_AliadosEdit }

procedure TFViewSincronizacao_AliadosEdit.btSaveClick(Sender: TObject);
begin
  if Sincronizacao_AliadosDataset.State in dsEditModes then
  begin
        Sincronizacao_AliadosDatasetsincronizacao_service.Value := cbsincronizacao_service.Items.Objects[cbsincronizacao_service.ItemIndex];
    Sincronizacao_AliadosDataset.Post;
    Sincronizacao_AliadosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewSincronizacao_AliadosEdit.btDeleteClick(Sender: TObject);
begin
  if Sincronizacao_AliadosDataset.State in dsEditModes then
    Sincronizacao_AliadosDataset.Post;
  XDataClientSincronizacao_AliadosDelete.Delete(Sincronizacao_AliadosDataset.EntitySetName,
    TJSObject(Sincronizacao_AliadosDataset.CurrentData));
end;


class function TFViewSincronizacao_AliadosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TWebForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSincronizacao_AliadosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewSincronizacao_AliadosEdit.InsertEntity;
begin
  Sincronizacao_AliadosDataset.Close;
  Sincronizacao_AliadosDataset.SetJsonData('{}');
  Sincronizacao_AliadosDataset.Open;
  Sincronizacao_AliadosDataset.Insert;
  TCrudUtils.LoadAssociationDataset(sincronizacao_serviceDataset, 'tabela');
end;

class function TFViewSincronizacao_AliadosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TWebForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_AliadosEdit(AForm).FInserting := AInserting;
    TFViewSincronizacao_AliadosEdit(AForm).FId := AId;
    TFViewSincronizacao_AliadosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSincronizacao_AliadosEdit(AForm).InsertEntity
    else
      TFViewSincronizacao_AliadosEdit(AForm).LoadEntity;
    TFViewSincronizacao_AliadosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_AliadosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_AliadosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Sincronizacao_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Sincronizacao_AliadosDataset.EntitySetName
    )
  );
  XDataClientSincronizacao_AliadosGet.Get(Sincronizacao_AliadosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSincronizacao_AliadosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewSincronizacao_AliadosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSincronizacao_AliadosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSincronizacao_AliadosEdit.XDataClientSincronizacao_AliadosGetLoad(Response: TXDataClientResponse);
begin
  Sincronizacao_AliadosDataset.Close;
  Sincronizacao_AliadosDataset.SetJsonData(Response.Result);
  Sincronizacao_AliadosDataset.Open;
  
  Sincronizacao_AliadosDataset.Edit;  
  TCrudUtils.LoadAssociationDataset(sincronizacao_serviceDataset, 'tabela');
end;

procedure TFViewSincronizacao_AliadosEdit.XDataClientSincronizacao_AliadosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewSincronizacao_AliadosEdit.XDataClientSincronizacao_AliadosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_AliadosEdit.Sincronizacao_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewSincronizacao_AliadosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSincronizacao_AliadosEdit.sincronizacao_serviceDatasetAfterOpen(DataSet: TDataSet);
begin
  TCrudUtils.PopulateAssociationCombobox(cbsincronizacao_service,
    TXDataWebDataSet(DataSet), 'tabela');

  if FInserting then
    cbsincronizacao_service.ItemIndex := -1
  else
  begin
    TCrudUtils.SelectAssociationItem(cbsincronizacao_service, Sincronizacao_AliadosDatasetsincronizacao_service);
  end;
end;

end.
